import { render, staticRenderFns } from "./SlideOverview.vue?vue&type=template&id=77f81db3&scoped=true"
import script from "./SlideOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./SlideOverview.vue?vue&type=script&setup=true&lang=js"
import style1 from "./SlideOverview.vue?vue&type=style&index=1&id=77f81db3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f81db3",
  null
  
)

export default component.exports